module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5elJR"))).then(() => parcelRequire('9Lwss'));